<router-outlet name="home"></router-outlet>


<app-cgu *ngIf="cguDisplayed"></app-cgu>
<app-iecook
  *ngIf="!cguDisplayed && cookieDisplayed"
  (manageCookies)="onManageCookies($event)"
></app-iecook>
<div class="cgu-iekooc-overlay-shadow" *ngIf="(cguDisplayed || cookieDisplayed)"></div>